export const PERMISSIONS = [
  'ROLE_SCOPE_MANAGE',
  'USER_CREATE',
  'USER_VIEW',
  'LIMIT_SCOPE_USER_VIEW',
  'USER_DELETE',
  'USER_UPDATE',
  'USER_LIST_VIEW',
  'LIMIT_SCOPE_USER_LIST_VIEW',
  'ALERT_SETTINGS_MANAGE',
  'MARKET_INTELLIGENCE_VIEW',
  'EMR_SYNC_MANAGE',
  'USER_ANALYTICS_VIEW',
  'STAFF_WAGES_VIEW',
  'STAFF_SALARY_EDIT',
] as const;

export type PERMISSION = (typeof PERMISSIONS)[number];

export enum PERMISSIONS_NAMES {
  ROLE_SCOPE_MANAGE = 'Manage Role Scopes',
  USER_CREATE = 'Create Users',
  USER_VIEW = 'View User Details',
  LIMIT_SCOPE_USER_VIEW = 'View Limited User Scope',
  USER_DELETE = 'Delete Users',
  USER_UPDATE = 'Edit Users',
  USER_LIST_VIEW = 'View User List',
  LIMIT_SCOPE_USER_LIST_VIEW = 'View Limited User List',
  ALERT_SETTINGS_MANAGE = 'Manage Alert Settings',
  MARKET_INTELLIGENCE_VIEW = 'View Market Intelligence',
  EMR_SYNC_MANAGE = 'Sync EMR',
  USER_ANALYTICS_VIEW = 'View User Analytics',
  STAFF_WAGES_VIEW = 'View wages & salaries',
  STAFF_SALARY_EDIT = 'Edit salaries',
}
